import { useState, useEffect, useContext } from 'react'
import style from '../index.module.scss'
import { PlusCircleOutlined, CheckOutlined, StarOutlined } from '@ant-design/icons';
import { message, Input } from 'antd'
import myContext from '../../../utils/context'
import { StorageModule } from '../../../modules/storage'

import * as apis2 from '../../../api/networkDisk'
// import { deepCopy } from "../../../util";
import {
    excellingTopic, reuqestCreatFavorite
} from '../../../api/networkDisk'
import { deepCopy } from '../../../util';
import { stringify } from 'querystring';
import * as apis from '../../../api/file'
import { stat } from 'fs';
import { idText } from 'typescript';

interface Props {
    getList?: any
    foldId?: string
    //指定参数，type=add是增加参数，type=cover是覆盖
    params?: any
    /**
     * 带选择的目录，可传参数
     */
    fileItemCheck?: any
    fileItemEdit?: any

    /**
    * 匿名插槽,不穿参数
    */
    children?: any

    type?: any
    /**
    * 列表，如果传入，覆盖默认的收藏夹列表请求
    */
    initList?: any
    /**
    * 是否使用自定义cusApi，如果传入，覆盖默认的收藏夹列表请求
    */
    /**
     * 调用源页面的属性，单列则点击item后不出发接口请求
     * limitCols表示单列
     */
    attributeType?: any
}
const user: any = StorageModule.getUser().user;

interface State {
    tree: any[];
    list: any[];
    delVisible: boolean;
    delInfo: any;
    moveTimer: any;
    isMove: boolean;
    moveNode: any;
    moveLeft: number;
    moveTop: number;
    offsetX: number;
    offsetY: number;
    startNode: any;
    moveIndex: number;
    startIndex: number;
    saveLoading: boolean;
    type: string;
    backParentId: any;
    activeItem: any

}
const M2niCascadedList = (props: Props,) => {
    const [state, setState] = useState<State>({
        tree: [],
        list: [],
        delVisible: false,
        delInfo: {},
        moveTimer: null,
        isMove: false,
        moveNode: {},
        moveLeft: 0,
        moveTop: 0,
        offsetX: 0,
        offsetY: 0,
        startNode: {},
        moveIndex: -1,
        startIndex: -1,
        saveLoading: false,
        type: '',
        backParentId: -1,
        activeItem: {}
    });
    const [boxWidth, setBoxWidth] = useState<any>(0);
    const [screenCol, setScreenCol] = useState<boolean>(false);
    //记录创建修改文件夹的id
    const [pid, setPid] = useState<any>();

    let itemInfo: any
    const reviceProps = useContext(myContext)
    useEffect(() => {
        setBoxWidth(document.getElementById("box")?.offsetWidth)

    }, [boxWidth])
    /**
     * 针对扫描
     */
    useEffect(() => {
        setTimeout(() => {
            init()
        }, 200);

    }, [props.initList.length, props.initList])
    /**
     * 针对图片预览里的相册
     */
    useEffect(() => {

        if (!props.initList || props.initList.length === 0) {
            init()
        }
    }, [reviceProps.checkListData?.length])
    /**
     * 初始化数据
     */
    const init = async (): Promise<void> => {
        if (props.initList) {
            /**
             * catalogueList传值代表，是同步目录
             * */
            dealList(deepCopy(props.initList))
            state.activeItem = props.initList[0]
            setState(state)
        } else {
            /**
             * catalogueList没传值，代表默认请求 收藏夹
             * */
            onGetList(0)
        }
    }

    const onGetList = async (colIndex: number = 0, param?: any, type?: string, item?: any): Promise<void> => {
        console.log('onGetList')
        //初始化时colIndex为应为0 所以传-1
        // colIndex=colIndex+1
        // console.log(param)
        if (props.attributeType && props.attributeType == 'limitCols') {
            return
        }
        try {
            let _param: any = param
            //自定义参数，如果传来，则根据type进行叠加或覆盖
            if (props.params) {
                if (props.params.type === 'add') {
                    _param = { ...param, ...props.params.data }
                } else {
                    _param = { ...props.params.data }
                }
            }
            console.log(_param)
            if (!_param.hasOwnProperty('userId') || !_param.userId) {
                _param.userId = user?.id.toString()
            }
            let response: any = await excellingTopic({ ..._param, permissionType: (user?.id.toString() != _param.userId) ? 'OVERT' : "" })
            dealList(JSON.parse(JSON.stringify(response.data)), colIndex, param, type, item)
        } catch (err) {
            console.log(err)
        }
    }
    /**
     * 处理不同功能传来的list格式
     * */
    const dealList = (response: any, colIndex: number = 0, param?: any, type?: string, item?: any) => {
        let list = response
        /**
        * @name 处理勾选，全选，全不选
        */
        if (props.type === 'check') {
            dealcheck(response, colIndex, param, type, item)
        }
        let arr = {
            isCompile: false,
            list: list,
            value: '',
            level: colIndex,
            // parentId: param ? param.parentId : null
        }
        state.list[colIndex] = arr
        state.list.splice(colIndex + 1, state.list.length)
        console.log(state.list)
        setState({ ...state })
        if (state.list[0]?.list?.length == 0) {
            setScreenCol(false)
        } else {
            setScreenCol(true)
        }
    }
    const dealcheck = (list: any, colIndex: number = 0, param?: any, type?: string, item?: any) => {
        let flag: any = false
        list?.map((i: any) => {
            /***
        * 因接口数据结构和请求参数不一样，做判断处理
        */
            if (!i.hasOwnProperty('id')) {
                i.id = i.id
            }
            i.isCheck = false
            i.checkShow = true
            if (colIndex != 0 && item) {
                i.isCheck = item.isCheck
                i.checkShow = !item.isCheck

            }
            //半选
            i.indeterminate = false
            reviceProps.checkListData?.map((j: any) => {
                if (i.id == j.id) {
                    i.isCheck = true
                }
            })
            reviceProps.setCheckItemData(i);
        })
        if (colIndex != 0) {
            state.list[colIndex - 1].list.map((i: any) => {
                i.indeterminate = true
            })
        }
    }
    /**
    * @name 新增icon-click
    */
    const onAddIconClick = (item: any) => {
        setScreenCol(true)
        item.isCompile = !item.isCompile
        item.value = ''
        setState({ ...state })
    }
    /**
     * @name 新增目录change
     */
    const onAddChange = (e: any, item: any): void => {
        item.value = e.target.value
        // item.isHover=true
        setState({ ...state })
    }
    /**
     * @name 新增收藏目录
     */
    const onAddFavorite = async (item: any, colIndex: number): Promise<any> => {

        if (item.value === '') {
            // message.info('请输入目录名称！')
            item.isCompile = false
            setState({ ...state })
            return
        }
        let judgeFn: any = new RegExp(/\s+/g);
        if (judgeFn.test(item.value)) {
            message.warning('名称不能有空格！')
            return
        }
        if (state.saveLoading) return
        state.saveLoading = true
        setState({ ...state })
        if (!item.list) {
            item.list = []
        }
        let params: any = {
            name: item.value,
            orderNum: item.list.length + 1,
            // parentId: null
        }
        if (colIndex === 0) {
            // params.parentId as any = null
        } else {
            // let ery: any = state.list[colIndex - 1].list.find((v: any) => v.isHover)
            params.parentId = pid
        }
        let response: any = null
        try {
            response = await reuqestCreatFavorite(params)
        } catch (err) {
            message.error('服务器异常！')
        }
        item.isCompile = false
        item.value = ''
        state.saveLoading = false
        setState({ ...state })
        if (response.ok) {

            onGetList(colIndex, { parentId: item.parentId }, 'addItem')
        }
    }
    const onCatalogueSelect = (item: any, list: any[], colIndex: number, index: number): void => {
        list.forEach((v: any) => {
            v.isHover = item.id === v.id
            v.isSelect = item.id === v.id
            v.isCompile = false
        })
        state.activeItem = item
        state.list[colIndex].list = list
        setState({ ...state })
        itemInfo = item
        reviceProps.setCheckItemData(item.id)
    }
    const onHover = (item: any, list: any[], colIndex: number) => {
        list.forEach((v: any) => {
            v.isHover = item.id === v.id
            v.isSelect = item.id === v.id
        })
        state.list[colIndex].list = list
        setState({ ...state })
        if (props.attributeType && props.attributeType == 'limitCols') {
            reviceProps.setCheckItemData(item.id)
        }

    }

    const onClickEdit = (type: any, index: number, colIndex: number) => {
        state.list[colIndex].list[index].isCompile = type
        setState({ ...state })
    }

    // abooutdrag
    // 拖动操作
    /**
     * @name 清除拖拽提示线
     */
    const clearMoveStatus = () => {
        state.list.forEach((item: any) => {
            item.list.forEach((v: any) => {
                v.top = false
                v.bottom = false
            })
        })
        setState({ ...state })
    }

    // item 节点node， listIndex列索引
    const setInitNode = (item: any, listIndex: number, e: any): void => {
        state.startNode = JSON.parse(JSON.stringify(item))
        state.startIndex = listIndex
        console.log('start', e)
        setState({ ...state })
    }
    let inter: any = 0;

    // item列的数据要包含parentId列id， list是列数据内容，masterIndex列索引
    const setMoveNode2 = (e: any, item: any, list?: any[], masterIndex?: number): void => {
        state.moveIndex = masterIndex || 0
        state.backParentId = item.parentId
        setState({ ...state })
    }
    /**
     * @name 获取当前节点数据
     */
    // item 节点node， colIndex列索引， masterIndex行索引
    const setMoveNode = (e: any, item: any, colIndex: number, masterIndex: number): void => {
        clearTimeout(inter)
        inter = setTimeout(() => {

            if ((colIndex > state.startIndex)
                && (!item || item.parentId === state.startNode.id)) {
                //clearMoveStatus()
                //return
            }
            let offsetY: number = e.nativeEvent.offsetY
            clearMoveStatus()
            if (item) {
                if (offsetY > 14) {
                    item.bottom = true
                } else {
                    item.top = true
                }
            }

            state.moveNode = item || {}
            state.moveIndex = colIndex;
            setState({ ...state })
        }, 0)
    }
    // let ismoving = false;
    const setMovePlace = async (e: any): Promise<any> => {
        console.log('end', e)

        if (state.activeItem.id == state.startNode.id && state.moveIndex != state.startIndex) {
            clearMoveStatus()
            message.error('目标主题不能与拖拽主题相同')
            return
        }
        //state.moveIndex=parseInt((e.clientX/254).toString())-1
        const startlist = state.list[state.startIndex];
        const startRowIndex = (startlist.list || []).findIndex((v: any) => {
            return state.startNode.id === v.id
        })
        console.log('end', 111)
        const endlist = state.list[state.moveIndex];
        const endRowIndex = (endlist.list || []).findIndex((v: any) => {
            //return state.moveNode.id === v.id
        })
        console.log('end', 2222)
        if (state.moveNode) {
            if (state.startNode.id === state.moveNode.id || (state.moveIndex > state.startIndex
                && (state.moveNode.parentId === state.startNode.id))) {
                clearMoveStatus()
                //return
            }
        }
        //state.startNode.parentId = state.moveNode.parentId;
        // ismoving = true
        let orderList: any = []
        // 删除旧的节点
        let oldIndex: number = state.list[state.startIndex].list.findIndex((v: any) => v.id === state.startNode.id)
        if (oldIndex !== -1) {
            state.list[state.startIndex].list.splice(oldIndex, 1)
            setState({ ...state })
        }
        // 添加新的节点
        let index: number = state.list[state.moveIndex].list.findIndex((v: any) => v.id === state.moveNode?.id) || 0
        if (state.backParentId) {
            index = state.list[state.moveIndex].list.findIndex((v: any) => v.id === state.backParentId) || 0
        }
        if (state.moveNode?.top) {
            state.list[state.moveIndex].list.splice(index, 0, state.startNode)
        } else if (state.moveNode?.bottom) {
            state.list[state.moveIndex].list.splice(index + 1, 0, state.startNode)
        } else if (state.backParentId) {
            state.list[state.moveIndex].list.push(state.startNode)
        } else {
            state.list[state.moveIndex].list.splice(-1, 0, state.startNode)
        }
        setState({ ...state })
        // 重新排序
        state.list[state.moveIndex].list.forEach((v: any, i: number) => {
            v.orderNum = i + 1
            orderList.push({
                id: v.id,
                order: v.orderNum
            })
        })
        setState({ ...state })
        // 清除拖拽提示线
        clearMoveStatus()

        // 生成修改参数
        let start = [];
        let end = [];
        if (state.startIndex !== state.moveIndex) {
            start = (startlist.list || []).filter((v: any, k: any) => {
                return k >= startRowIndex
            }).map((v: any) => {
                return {
                    ...v,
                    orderNum: v.orderNum - 1
                }
            });
            end = (endlist.list || []).filter((v: any, k: any) => {
                return k >= endRowIndex
            });
        } else {
            const max = Math.max(startRowIndex, endRowIndex)
            const min = Math.min(startRowIndex, endRowIndex)
            start = (startlist.list || []).filter((v: any, k: any) => {
                return (k >= (min - 1)) && (k <= max)
            });
        }

        const params = [
            ...start,
            ...end
        ]
        console.log(state.moveIndex, state.startIndex, state.startNode)
        if (state.moveIndex == state.startIndex) {
            clearMoveStatus()
            return
        }
        const pid = state.startIndex == 1 && state.moveIndex == 0 ? state.moveNode.parentId : state.activeItem.id

        const res = await apis.updateTopicParent(state.startNode.id, pid)
        console.log(res)
        //props.getList()
        clearMoveStatus()
        /*
        //let response: any = await apis2.excellingTopic()
        //state.tree = JSON.parse(JSON.stringify(response.data))
        
        let curitem = state.tree
        state.list.forEach(v => {
            if (!v.parentId) {
                v.list = curitem
            }
            // else {
            //     curitem = (curitem.find(t => {
            //         return t.id === v.id
            //     }) || {}).children || []
            //     v.list = curitem
            // }
        })
        // 清除拖拽提示线
        clearMoveStatus()
        state.backParentId = ''
        setState({ ...state })
        // ismoving = false
        */
    }


    return (
        <div >
            <div data-flex='main:left' className={'selectionFolder_list'} id='box'>
                {

                    (state.list || []).sort((a: any, b: any) => a.orderNum - b.orderNum).map((item: any, colIndex: number) => (
                        <div className={style.list_column}
                            style={(!screenCol) ? { flex: 1, alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'column' } : {}}
                            key={colIndex}

                            onDragOver={(e: any) => {
                                setMoveNode2(e, { parentId: item.id }, item.list, colIndex)
                            }}
                        >
                            {/* {props.children && props.children} */}

                            {
                                item.list && item.list.map((v: any, index: number) => (
                                    <div key={colIndex + '_' + index}
                                        style={{
                                            borderTop: v.top ? '1px solid #FFC400' : 'none',
                                            borderBottom: v.bottom ? '1px solid #FFC400' : 'none'
                                        }}

                                    >
                                        <div onMouseEnter={() => onHover(v, item.list, colIndex)} onClick={() => {
                                            onCatalogueSelect(v, item.list, colIndex, index)
                                        }}>
                                            {props.fileItemCheck && props.fileItemCheck(v, index, colIndex, onGetList, onClickEdit)}
                                            <div onMouseEnter={
                                                () => {
                                                    v.isHover = true

                                                    setState({ ...state })
                                                    setPid(v.id)
                                                }}

                                                onMouseLeave={() => {
                                                    v.isHover = false
                                                    setState({ ...state })
                                                }}>{props.fileItemEdit && props.fileItemEdit(v, index, colIndex,
                                                    onClickEdit,
                                                    setMoveNode,
                                                    setMovePlace,
                                                    state.list,
                                                    setInitNode, onGetList)}</div>

                                        </div>
                                    </div>
                                ))

                            }
                            {/* 
                            针对收藏夹的片段
                            */}
                            {
                                item.isCompile &&
                                <div className={`${style.list_column_item} ${style.active}`}
                                    onBlur={(e) => {
                                        console.log('1')
                                        setTimeout(() => {
                                            item.isCompile = false
                                            // item.isHover = false
                                            setState({ ...state })
                                        }, 200)
                                    }}>
                                    <Input
                                        onChange={(e) => onAddChange(e, item)}

                                        type="text"
                                        placeholder="未命名分类"
                                        autoFocus
                                        value={item.value}
                                        className={style.input}
                                        suffix={
                                            <CheckOutlined className={style.icon_more} onClick={(e) => {
                                                e.stopPropagation();
                                                onAddFavorite(item, colIndex)
                                            }} />
                                        } />
                                </div>
                            }
                        </div>
                    ))
                }

                {

                    // 最后的自适应栏，小于三栏时展示，当没有任何相册数据是不展示
                    screenCol ?
                        <div className={style.list_column + ' ' + style.lastChild}></div> : <></>
                }
            </div>
        </div>
    )
}

export default M2niCascadedList